export enum ProductSidePanelTabValues {
    Details = 'details',
    Properties = 'properties',
}
